module.exports = __webpack_public_path__ + "static/media/removeFavoriteHeartIcon.8e6250ef.svg";